var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1662756,39.3839234 L72.1662756,24.6149521 C72.1662756,11.0421269 60.6531177,0 46.5,0 C32.3468823,0 20.8337244,11.0415642 20.8337244,24.6149521 L20.8337244,39.3839234 C13.7618002,39.3839234 8,44.9091503 8,51.6919621 L8,83.6919624 C8,90.4742116 13.7612135,96 20.8337244,96 L72.1662756,96 C79.2381998,96 85,90.4747743 85,83.6919624 L85,51.6919621 C85,44.9008234 79.2387865,39.3839234 72.1662756,39.3839234 Z M27,25 C27,13.9732571 36.1975886,5 47.5,5 C58.8024114,5 68,13.9732571 68,25 L68,40 L27,40 L27,25 Z M81,83.5790366 C81,87.6738253 77.5349662,91 73.2692308,91 L21.7307692,91 C17.4650338,91 14,87.6738253 14,83.5790366 L14,51.4209634 C14,47.3261747 17.4650338,44 21.7307692,44 L73.2692308,44 C77.5349662,44 81,47.3261747 81,51.4209634 L81,83.5790366 Z",
    fill: "#000",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bce9938f8c01d2b6e128e79c0d0704e9.svg";
export { ForwardRef as ReactComponent };